import { useEffect, useState } from "react";
import { SalaryHeader } from "../../../components/SalaryHeader";
import { SalarySettings } from "../../../components/SalarySettings";
import { EarningsSection } from "../../../components/EarningsSection";
import { CompliancesSection } from "../../../components/CompliancesSection";
import { DeductionsSection } from "../../../components/DeductionsSection";
import { TotalCTC } from "../../../components/TotalCTC";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";
import ClipLoader from "react-spinners/ClipLoader";

export default function SalaryDetails() {
  const [effectiveDate, setEffectiveDate] = useState(new Date().toISOString().slice(0, 7));
  const [salaryType, setSalaryType] = useState("Per Month");
  const [salaryStructure, setSalaryStructure] = useState("custom");
  const [ctcAmount, setCtcAmount] = useState("0.00");
  const { baseUrl, selectedStaff } = useGlobalContext();
  const [loading, setLoading] = useState({
    fetchSalary: false,
    fetchEarnings: false,
    fetchDeductions: false
  });



  const [earnings, setEarnings] = useState([
  ]);

  const [employerContributions, setEmployerContributions] = useState({
    pf: { amount: 0, calculation: "", includedInCTC: false, selectedEarnings: [] },
    pfEDLI: { amount: 0, calculation: "", includedInCTC: false, selectedEarnings: [] },
    esi: { amount: 0, calculation: "", includedInCTC: false, selectedEarnings: [] },
    lwf: { amount: 0, state: "", includedInCTC: false, selectedEarnings: [] },
  });

  const [employeeContributions, setEmployeeContributions] = useState({
    pf: { amount: 0, calcuation: "", selectedEarnings: [] },
    esi: { amount: 0, calcuation: "", selectedEarnings: [] },
    professionalTax: { amount: 0, calcuation: "", state: "", selectedEarnings: [] },
    lwf: { calcuation: "", amount: 0, state: "", selectedEarnings: [] },
  });


  const getIncludedCTCAmounts = () => {
    let employerIncludedAmounts = 0;
    let employeeIncludedAmounts = 0;

    Object.keys(employerContributions).forEach((key) => {
      const contribution = employerContributions[key];
      if (contribution.includedInCTC) {
        employerIncludedAmounts += contribution.amount;
      }
    });

    Object.keys(employeeContributions).forEach((key) => {
      const contribution = employeeContributions[key];
      employerIncludedAmounts += contribution.amount;
    });

    return { employerIncludedAmounts, employeeIncludedAmounts };
  };


  const [deductions, setDeductions] = useState([
  ]);

  const handleEarningChange = (name, value, field) => {
    setEarnings(
      earnings.map((earning) =>
        earning.name === name ? { ...earning, [field]: value } : earning
      )
    );
  };

  const handleComplianceChange = (section, field, value, type) => {
    if (section === "employer") {
      setEmployerContributions((prev) => ({
        ...prev,
        [field]: { ...prev[field], [type]: value },
      }));
    } else {
      setEmployeeContributions((prev) => ({
        ...prev,
        [field]: { ...prev[field], [type]: value },
      }));
    }
  };

  const handleDeductionChange = (name, value, field) => {
    setDeductions(
      deductions.map((deduction) =>
        deduction.name === name ? { ...deduction, [field]: value } : deduction
      )
    );
  };

  const totalCTC = () => {
    let total = 0;

    earnings.forEach((earning) => {
      total += parseFloat(earning.amount || 0);
    });

    const includedAmounts = getIncludedCTCAmounts() || {};
    const employerIncludedAmounts = parseFloat(includedAmounts.employerIncludedAmounts || 0);
    const employeeIncludedAmounts = parseFloat(includedAmounts.employeeIncludedAmounts || 0);

    const finalTotal = total + employerIncludedAmounts + employeeIncludedAmounts;
    setCtcAmount(finalTotal.toFixed(2));
  };


  const getSalaryData = async () => {
    try {
      // Set loading state to true for salary fetching
      setLoading((prevLoading) => ({
        ...prevLoading,
        fetchSalary: true,
      }));

      // Construct API URL
      const apiUrl = `${baseUrl}salary/single/${selectedStaff?.staffDetails?.id}/date=${effectiveDate?.split("-")?.reverse()?.join("/")}`;

      // Fetch data
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      // Parse response
      const result = await response.json();
      console.log(result);
      if (response.ok) {

        if (result?.data?.length === 0) {
          setEarnings([{ name: "Basic", type: "On Attendance", amount: "" }]);
          setDeductions([]);
          return;
        }

        const employerContribution = result?.data?.[0]?.Staff?.EmployerContribution?.filter((contribution) => contribution?.contribution_month === effectiveDate);
        const employeeContribution = result?.data?.[0]?.Staff?.EmployeeContribution?.filter((contribution) => contribution?.contribution_month === effectiveDate);

        employerContribution.forEach((contribution) => {
          setEmployerContributions((prev) => ({
            ...prev,
            [contribution?.type]: {
              ...prev[contribution?.type],
              amount: contribution?.amount,
              calculation: contribution?.calculation,
              includedInCTC: contribution?.includedInCTC,
              selectedEarnings: contribution?.selected_earnings,
              state: contribution?.state
            },
          }))
        });

        employeeContribution.forEach((contribution) => {
          setEmployeeContributions((prev) => ({
            ...prev,
            [contribution?.type]: {
              ...prev[contribution?.type],
              amount: contribution?.amount,
              calculation: contribution?.calculation,
              includedInCTC: contribution?.includedInCTC,
              selectedEarnings: contribution?.selected_earnings,
              state: contribution?.state
            },
          }))
        });

        // Map earnings and ensure no duplicates
        const fetchedEarnings = result?.data?.[0]?.Staff?.Earning?.filter(
          (earning) => earning?.salary_month === effectiveDate
        ).map((earning) => ({
          id: earning?.id,
          name: earning?.heads || "Basic",
          type: earning?.calculation || "On Attendance",
          amount: earning?.amount || 0,
        })) || [
            { name: "Basic", type: "On Attendance", amount: "" },
          ];


        // Map deductions
        const fetchedDeductions = result?.data?.[0]?.Staff?.Deduction?.filter(
          (deduction) => deduction?.deduction_month === effectiveDate
        ).map((deduction) => ({
          id: deduction?.id,
          name: deduction?.heads || "Professional Tax",
          type: deduction?.calculation || "On Attendance",
          amount: deduction?.amount || 0,
        })) || [];

        // Avoid duplicate entries by filtering out existing entries
        const uniqueEarnings = fetchedEarnings.filter(
          (earning, index, self) =>
            index === self.findIndex((e) => e.name === earning.name)
        );

        const uniqueDeductions = fetchedDeductions.filter(
          (deduction, index, self) =>
            index === self.findIndex((e) => e.name === deduction.name)
        );

        console.log(uniqueEarnings, uniqueDeductions);

        setEarnings(uniqueEarnings);
        setDeductions(uniqueDeductions);
      } else {
        console.error("Failed to retrieve data:", response.status, response.statusText);
      }
    } catch (error) {
      console.error("An error occurred while fetching salary data:", error);
    } finally {
      // Set loading state to false after the process
      setLoading((prevLoading) => ({
        ...prevLoading,
        fetchSalary: false,
      }));
    }
  };



  useEffect(() => {
    setEarnings([{ name: "Basic", type: "On Attendance", amount: "" }]);
    setDeductions([]);
    if (effectiveDate !== "") {
      getSalaryData();
    }
  }, [effectiveDate]);

  useEffect(() => {
    totalCTC();
  }, [earnings, employerContributions, employeeContributions, deductions, effectiveDate]);


  return (
    <div className={"min-h-screen " + ((loading.fetchDeductions || loading.fetchEarnings || loading.fetchSalary) && "flex flex-col items-center")}>
      <SalaryHeader
        updateSalaryDetails={() => {
          setCtcAmount(0.00);
          setEarnings([]);
          setDeductions([]);
          setEmployerContributions({
            pf: { type: "None", amount: "", calcuation: "", includedInCTC: false, selectedEarnings: [] },
            pfEDLI: { type: "None", amount: "", calcuation: "", selectedEarnings: [], includedInCTC: false },
            esi: { type: "None", amount: "", calcuation: "", includedInCTC: false, selectedEarnings: [] },
            lwf: { type: "None", amount: "", state: "", includedInCTC: false, selectedEarnings: [] },
          });
          setEmployeeContributions({
            pf: { type: "None", amount: "", type: "On Attendance", selectedEarnings: [] },
            esi: { type: "None", amount: "", type: "On Attendance", selectedEarnings: [] },
            professionalTax: { type: "None", amount: "", state: "", selectedEarnings: [] },
            lwf: { type: "None", amount: "", state: "", selectedEarnings: [] },
          })
          getSalaryData();
        }}

        effectiveDate={effectiveDate} salaryType={salaryType} earnings={earnings}
        deductions={deductions}
        employeeContributions={employeeContributions}
        employerContributions={employerContributions} totalCTC={parseFloat(ctcAmount)}

      />
      {
        (loading.fetchDeductions || loading.fetchEarnings || loading.fetchSalary
        ) ? (<ClipLoader color="#4A90E2" size={40} />)
          : (<>
            <div className="relative space-y-6 w-full">
              <SalarySettings
                effectiveDate={effectiveDate}
                setEffectiveDate={setEffectiveDate}
                salaryType={salaryType}
                setSalaryType={setSalaryType}
                salaryStructure={salaryStructure}
                setSalaryStructure={setSalaryStructure}
                ctcAmount={ctcAmount}
                setCtcAmount={setCtcAmount}
              />

              <EarningsSection
                effectiveDate={effectiveDate}
                earnings={earnings}
                handleChange={handleEarningChange}
                setEarnings={setEarnings}
              />

              <CompliancesSection
                effectiveDate={effectiveDate}
                employeeContributions={employeeContributions}
                employerContributions={employerContributions}
                setEmployerContributions={setEmployerContributions}
                setEmployeeContributions={setEmployeeContributions}
                handleChange={handleComplianceChange}
                earnings={earnings}
              />

              <DeductionsSection
                effectiveDate={effectiveDate}
                deductions={deductions}
                handleChange={handleDeductionChange}
                setDeductions={setDeductions}
              />

              <TotalCTC amount={parseFloat(ctcAmount)} salaryType={salaryType} />
            </div>
          </>
          )}
    </div>
  );
}